import { render, staticRenderFns } from "./ClubStats.vue?vue&type=template&id=cca321d0&scoped=true&"
import script from "./ClubStats.vue?vue&type=script&lang=js&"
export * from "./ClubStats.vue?vue&type=script&lang=js&"
import style0 from "./ClubStats.vue?vue&type=style&index=0&id=cca321d0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca321d0",
  null
  
)

component.options.__file = "ClubStats.vue"
export default component.exports